import { createSlice } from "@reduxjs/toolkit";
import { BuscaContaContabilModel } from "../../../models/planoContaContabil/buscaContaContabilModel";
import { PlanoContaContabilDTOModel } from "../../../models/planoContaContabil/planoContaContabilDTOModel";
import { SelectModel } from "../../../models/treeModel";
import { buscarPlanoContaContabil } from "../../../services/planoContaContabilService";
import { resetAll } from "../../actions/actions";

export interface PlanoContaContabilState {
  //buscar plano de conta contabil
  loading: boolean;
  busca: BuscaContaContabilModel;
  list: PlanoContaContabilDTOModel[];
  entity: PlanoContaContabilDTOModel;
  //internal
  modalCadastrar: boolean;
  modalDeletar: boolean;
}

const initialState: PlanoContaContabilState = {
  //buscar plano de conta contabil
  loading: false,
  busca: {
    denominacao: null,
    usoSistema: false,
    ativo: null,
  } as BuscaContaContabilModel,
  list: [],
  entity: {} as PlanoContaContabilDTOModel,
  //internal
  modalCadastrar: false,
  modalDeletar: false,
};

export const planoContaContabilSlice = createSlice({
  name: "planoContaContabil",
  initialState,
  reducers: {
    //buscar plano de conta contabil
    setBuscaPlanoContaContabil: (state, action) => {
      state.busca = action.payload;
    },
    setEntityPlanoContaContabil: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setModalCadastrarPlanoContaContabil: (state, action) => {
      state.modalCadastrar = action.payload;
    },
    setModalDeletarPlanoContaContabil: (state, action) => {
      state.modalDeletar = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar plano de conta contabil
    builder.addCase(buscarPlanoContaContabil.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarPlanoContaContabil.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarPlanoContaContabil.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar plano de conta contabil
  setBuscaPlanoContaContabil,
  setEntityPlanoContaContabil,
  //internal
  setModalCadastrarPlanoContaContabil,
  setModalDeletarPlanoContaContabil,
} = planoContaContabilSlice.actions;

export default planoContaContabilSlice.reducer;
